module.exports = __webpack_public_path__ + "static/media/banesco-bumper_selected.0904d1cd.svg";